import { useClassNames } from '@magnetic/hooks';
import { Text } from '@magnetic/text';
import React from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Heading = /* @__PURE__ */ __name(({ heading }) => {
  if (!heading) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Text, {
    className: "mds-rebuild-nav-item-content-heading line-clamp",
    size: "p4"
  }, heading);
}, "Heading");
const NavItemContent = /* @__PURE__ */ __name(({
  heading,
  isActive,
  isSwitcher,
  label
}) => {
  const { isCollapsed, isIconOnly } = useNavContext();
  const classNames = useClassNames("line-clamp", {
    "mds-rebuild-nav-item-content-label-collapsed": isCollapsed,
    "mds-rebuild-nav-item-content-label": !isCollapsed,
    "mds-rebuild-nav-item-is-inactive": !isActive && !isSwitcher
  });
  if (isCollapsed && isIconOnly) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, !isCollapsed && heading && /* @__PURE__ */ React.createElement(Heading, {
    heading
  }), /* @__PURE__ */ React.createElement(Text, {
    className: classNames,
    size: isCollapsed ? "p4" : "p3",
    weight: "semi-bold"
  }, label));
}, "NavItemContent");

export { NavItemContent };
//# sourceMappingURL=content.js.map
